<div *ngIf="calculateOnly">
	<!-- <button class="button-simple" (click)="clickCompute()">
		<div class="same-line">
			<i class="glyphicons glyphicons-calculator"></i>
			<div>Compute</div>
		</div>
	</button> -->
	<!-- <input disabled placeholder="To be computed."> -->
	<div style="font-style: italic;color:gray;">To be computed.</div>
</div>
<ng-container *ngIf="!calculateOnly">
	<div class="same-line" title="e.g. urn:emergency:uri:&#123;00006FF0-4486-4641-825E-A9446C2EB8BX&#125;:{{discrepancyAgencyId ? discrepancyAgencyId : 'state.gov'}}">
		<input name="givNguidPattern" type="radio" [value]="false" [(ngModel)]="nguidPattern.layerType" (ngModelChange)="onChangePattern()">
	
		<div>urn:emergency:uri:{{'&lt;Global ID&gt; : &lt;Discrepancy Agency ID&gt;'}}</div>
	</div>
	
	<div class="same-line" style="margin-top: 8px;" title="e.g. urn:emergency:uri:SSAP:&#123;00006FF0-4486-4641-825E-A9446C2EB8BX&#125;:{{discrepancyAgencyId ? discrepancyAgencyId : 'state.gov'}}">
		<input name="givNguidPattern" type="radio" [value]="true" [(ngModel)]="nguidPattern.layerType"(ngModelChange)="onChangePattern()">
	
		<div>urn:emergency:uri:{{'&lt;Layer Type&gt; : &lt;Global ID&gt; : &lt;Discrepancy Agency ID&gt;'}}</div>
	</div>
</ng-container>
